import React from "react";
import { useTranslation } from "react-i18next";
import { BiSolidErrorAlt } from "react-icons/bi";
import { CRIMSON_RED } from "../../enums/Colors";
import FullScreenMessageCore from "./FullScreenMessageCore";

export default function NotFoundFullScreenMessage({testId}) {
  const { t } = useTranslation();
  return (
    <FullScreenMessageCore
      icon={<BiSolidErrorAlt size={150} color={CRIMSON_RED} />}
      title={t("SomethingWentWrongErrorTemplateTitle")}
      subtitle={t("SomethingWentWrongErrorTemplateSubtitle")}
      testId={testId}
    />
  );
}
